import { IRootState } from "@/store/types";
import { Module } from "vuex";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { IProgramContent } from "@/models/programcontent";

export interface IProgramContentState {
    programContentsList: IProgramContent[] | null;
    selectedProgramContent: IProgramContent | null;
    error: any;
}

export const getDefaultPCState = (): IProgramContentState => {
    return {
        programContentsList: [],
        selectedProgramContent: null,
        error: null,
    };
};

// initial state
const state = getDefaultPCState();

const namespaced: boolean = true;

export const programContents: Module<IProgramContentState, IRootState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
